(function(){
'use strict';

angular.module('classy').component('modalSubtitle', {
  template: '<p class="modal__subtitle" data-ng-transclude></p>',
  transclude: true
});
})();